import React from 'react';

import './css/globals-v120.css';

interface PortalLayout120Props {
  children: React.ReactNode;
}

const PortalLayout120: React.FC<PortalLayout120Props> = ({ children }) => {
  return (
    <div className="min-h-screen bg-[rgb(252,252,252)]">
      {children}
    </div>
  );
};

export default PortalLayout120;
